import React from 'react';
import Button from '../ui/Button';
import { MessageCircleIcon, ShieldCheckIcon, DollarSignIcon, CheckCircleIcon } from 'lucide-react';
import { trackContact } from '../tracking/metaPixel';
import { useLanguage } from '../../context/LanguageContext';
const MidPageCTA = () => {
  const {
    language
  } = useLanguage();
  const content = {
    es: {
      headline: '¿Listo para dar el primer paso?',
      subline: 'Sin compromiso. Solo una conversación honesta.',
      cta: 'Hablar con Pedro',
      badges: [{
        icon: <ShieldCheckIcon className="w-5 h-5" data-id="element-275" data-mp="37x7ddy8f79j4" />,
        text: 'Sin obligación'
      }, {
        icon: <MessageCircleIcon className="w-5 h-5" data-id="element-276" data-mp="32vrvgf1jhj4y" />,
        text: 'Atención en español'
      }, {
        icon: <DollarSignIcon className="w-5 h-5" data-id="element-277" data-mp="2y0vyr1lcy7li" />,
        text: 'Ayuda con financiamiento'
      }]
    },
    en: {
      headline: 'Ready to take the first step?',
      subline: 'No commitment. Just an honest conversation.',
      cta: 'Chat with Pedro',
      badges: [{
        icon: <ShieldCheckIcon className="w-5 h-5" data-id="element-278" data-mp="es2bv3pmqpbk" />,
        text: 'No obligation'
      }, {
        icon: <MessageCircleIcon className="w-5 h-5" data-id="element-279" data-mp="4vzesc9mxgvh" />,
        text: 'Spanish support'
      }, {
        icon: <DollarSignIcon className="w-5 h-5" data-id="element-280" data-mp="9uamohgddhb2" />,
        text: 'Financing assistance'
      }]
    }
  };
  const t = content[language];
  return <section className="py-12 px-4 bg-primary text-white relative overflow-hidden" data-id="element-281" data-mp="3r97dbarw3xuh">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] pointer-events-none" data-id="element-282" data-mp="3iam0zxd0hf25"></div>

      <div className="container mx-auto max-w-4xl relative z-10" data-id="element-283" data-mp="3nai29oubqse0">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-284" data-mp="38bxsbp6x2cb4">
          {/* Text Content */}
          <div className="text-center md:text-left flex-1" data-id="element-285" data-mp="3dahftu15rw5l">
            <h2 className="font-heading font-bold text-2xl md:text-3xl mb-2" data-id="element-286" data-mp="2u6xghvklnxmr">
              {t.headline}
            </h2>
            <p className="text-gray-300 text-lg" data-id="element-287" data-mp="2pfnsezep92cz">{t.subline}</p>

            {/* Trust Badges (Desktop) */}
            <div className="hidden md:flex gap-6 mt-6" data-id="element-288" data-mp="2kgb9gpqy8ffo">
              {t.badges.map((badge, idx) => <div key={idx} className="flex items-center gap-2 text-sm text-gray-300" data-id="element-289" data-mp="2fj2nsf6ldt9o" data-mpi={idx}>
                  <div className="text-accent" data-id="element-290" data-mp="3d3p76q2h1f0u">{badge.icon}</div>
                  <span data-id="element-291" data-mp="38805oh6w5o1w">{badge.text}</span>
                </div>)}
            </div>
          </div>

          {/* CTA Button */}
          <div className="flex-shrink-0" data-id="element-292" data-mp="339f68jzgr8ei">
            <Button href="#lead-form" variant="success" size="lg" className="shadow-lg hover:shadow-xl hover:scale-105 transition-all font-bold px-8" onClick={() => trackContact({
            location: 'mid_page_cta',
            language,
            action: 'scroll_to_form'
          })} data-id="element-293" data-mp="2y9apcsun8bnr">
              <MessageCircleIcon className="w-5 h-5 mr-2" data-id="element-294" data-mp="7ao2kjnk4bj3" />
              {t.cta}
            </Button>
          </div>
        </div>

        {/* Trust Badges (Mobile) */}
        <div className="flex flex-wrap justify-center gap-4 mt-8 md:hidden border-t border-white/10 pt-6" data-id="element-295" data-mp="h199qvhaqodm">
          {t.badges.map((badge, idx) => <div key={idx} className="flex items-center gap-2 text-xs text-gray-300 bg-white/5 px-3 py-1.5 rounded-full" data-id="element-296" data-mp="m1n63g9jc9vt" data-mpi={idx}>
              <div className="text-accent" data-id="element-297" data-mp="v1a740ycrdoc">{badge.icon}</div>
              <span data-id="element-298" data-mp="zzlk2kjy24as">{badge.text}</span>
            </div>)}
        </div>
      </div>
    </section>;
};
export default MidPageCTA;